export const SALESFORCE_CAMPAIGN_ID = 'salesforcecampaignids';
export const HUBSPOT_OWNER_ID = 'hubspot_owner_id';
export const CAMPAIGN_ID = 'campaignId';
export const TAGS = 'tags';